import { mdiLoading } from '@mdi/js';
import Icon from '@mdi/react';
import { ReactNode, useContext } from 'react';
import { AppAgentContext } from '../../../context/ContextProvider';
import { DataStates, State } from '../../../store';
import { ModalType } from '../../../types/Modal';
import ModalComponent from './index';
import { useTranslate } from 'sbx-crm-menu-ui';

export interface ConfirmationProps {
    title: string | ReactNode;
    description: string;
    onConfirm: () => void;
    onClose: () => void;
    state?: DataStates;
    className?: string;
    confirmButtonClassName?: string;
    cancelButtonClassName?: string;
    titleClassName?: string;
}

export type ConfirmationPropsWrapper = { type: ModalType.CONFIRMATION, data: ConfirmationProps };

export const ConfirmationModal = ({
                                      title,
                                      description,
                                      onConfirm,
                                      onClose,
                                      state,
                                      className = '!bg-gradient-to-br !from-purple-50 !to-pink-50 !rounded-3xl !shadow-2xl w-full max-w-md overflow-hidden',
                                      titleClassName = "text-2xl text-center font-bold text-purple-800",
                                      confirmButtonClassName = 'bg-gradient-to-r btn from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white w-[200px]',
                                      cancelButtonClassName = 'border-pink-500 btn text-pink-600 hover:bg-pink-50 w-[200px] ',
                                  }: ConfirmationProps) => {
    const { t: common } = useTranslate('common');
    const { state: { loading } } = useContext(AppAgentContext);

    const isLoading = state ? loading[state] === State.LOADING : false;

    return (
        <ModalComponent onClose={onClose} className={`${className || 'bg-white'}`} titleClassName={titleClassName}
                        title={title}>
            {() => (
                <div>
                    <p className="text-center">{description} </p>

                    <div className="flex justify-center gap-3 mt-3">
                        <button
                            disabled={isLoading}
                            onClick={onConfirm}
                            className={`${confirmButtonClassName || 'btn btn-sm flex'}`}
                        >
                            {isLoading && <Icon className="mr-1" size={.7} path={mdiLoading} spin />} {common('yes')}
                        </button>

                        <button
                            disabled={isLoading}
                            onClick={onClose}
                            className={`${cancelButtonClassName || 'btn btn-sm'}`}
                        >
                            No
                        </button>
                    </div>
                </div>
            )}
        </ModalComponent>
    );
};